var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.deleteAccountConditions
      ? _c("div", { staticClass: "row p-lg-4 p-3" }, [
          _c(
            "div",
            {
              staticClass:
                "col-lg-6 offset-lg-3 col-12 delete-account-conditions"
            },
            [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$i18n.locale === "th"
                      ? _vm.deleteAccountConditions.detail_th
                      : _vm.deleteAccountConditions.detail_en
                  )
                }
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              !_vm.deleteAccountConditions.can_delete_account
                ? _c("div", { staticClass: "pb-4" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("message.delete_account.cannot_delete_remark")
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex justify-content-start align-items-center"
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-fill text-left" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn-link",
                          attrs: { to: "/user/edit" }
                        },
                        [
                          _vm._v(
                            "\n            < " +
                              _vm._s(
                                _vm.$t("message.booking.new_booking.back")
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-fill text-right" }, [
                    _vm.deleteAccountConditions.can_delete_account
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-danger",
                            on: {
                              click: function($event) {
                                return _vm.openDeleteAccountDialog()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("message.delete_account.title")) +
                                "\n          "
                            )
                          ]
                        )
                      : _c(
                          "a",
                          {
                            staticClass: "btn btn-info",
                            attrs: {
                              href: "https://line.me/R/ti/p/%40hnk7011n",
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("message.button.contact_admin")) +
                                "\n          "
                            )
                          ]
                        )
                  ])
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72bfedae", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72bfedae","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/DeleteAccount.vue
// module id = 1832
// module chunks = 0